var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 8.33317H15.8332C17.4998 8.33317 18.3332 7.49984 18.3332 5.83317V4.1665C18.3332 2.49984 17.4998 1.6665 15.8332 1.6665H14.1665C12.4998 1.6665 11.6665 2.49984 11.6665 4.1665V5.83317C11.6665 7.49984 12.4998 8.33317 14.1665 8.33317Z",
    stroke: "#66788A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 18.3332H5.83317C7.49984 18.3332 8.33317 17.4998 8.33317 15.8332V14.1665C8.33317 12.4998 7.49984 11.6665 5.83317 11.6665H4.1665C2.49984 11.6665 1.6665 12.4998 1.6665 14.1665V15.8332C1.6665 17.4998 2.49984 18.3332 4.1665 18.3332Z",
    stroke: "#66788A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 8.33317C6.84079 8.33317 8.33317 6.84079 8.33317 4.99984C8.33317 3.15889 6.84079 1.6665 4.99984 1.6665C3.15889 1.6665 1.6665 3.15889 1.6665 4.99984C1.6665 6.84079 3.15889 8.33317 4.99984 8.33317Z",
    stroke: "#66788A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 18.3332C16.8408 18.3332 18.3332 16.8408 18.3332 14.9998C18.3332 13.1589 16.8408 11.6665 14.9998 11.6665C13.1589 11.6665 11.6665 13.1589 11.6665 14.9998C11.6665 16.8408 13.1589 18.3332 14.9998 18.3332Z",
    stroke: "#66788A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.8a9722b9277070010da371e057a417b1.svg";
export { ForwardRef as ReactComponent };